<div id="myModal" class="event-modal">

  <app-loader *ngIf="isLoadingPage"></app-loader>
  <div class="full-width flex-utility direction-column align-center justify-center event-page"
    [class.show]="!isLoadingPage">
    <div class="event-wrapper flex-utility direction-column align-left">
      <p style="text-transform: uppercase;"> {{ "PAGES.EVENT.SELECT_EVENT" | translate}} </p>
    </div>
    <span>
      <div class="button-row" (click)="openDialogChooseEvent()">
        <button class="event-selected-button-dialog" aria-label="">

          {{selectedEvent ? selectedEvent.title : ('PAGES.EVENT.CLICK_TO_OPEN_SELECT_EVENT'|translate) }}
          <img class="image-text" src="../../../assets/images/dropdown_icon_filled.svg" />
        </button>
      </div>
    </span>
    <button (click)="doneIsPressed()" [disabled]="!selectedEvent" type="button" mat-stroked-button class="event-button">
      {{('BUTTON.DONE' | translate) | uppercase }}
    </button>
  </div>
</div>